import { getParameterByName } from './queryParams.js';
import { setCookie, getCookie } from './cookies.js';

const subIdParam = 's1';
const subIdcookieName = 'rc_sid';
const subIdcookieDays = 14;
const camIdParam = 'camid';
const camCookieName = 'rc_cid';
const camCookieDays = 14;

export const getSubId = () => {
  let subId = getParameterByName(subIdParam);
  if (subId === '' && typeof window.cf_dg_clk_id !== 'undefined' && typeof window.ckm_request_id !== 'undefined' && window.cf_dg_clk_id !== '' && window.ckm_request_id !== '') {
    subId = `${window.cf_dg_clk_id}.${window.ckm_request_id}`;
  }
  if (subId !== null && subId !== '') {
    setCookie(subIdcookieName, subId, subIdcookieDays);
    return subId;
  }
  return getCookie(subIdcookieName);
};

export const getCamId = () => {
  let camId = getCookie(camCookieName);
  if (camId === null || camId === '') {
    camId = getParameterByName(camIdParam);
    setCookie(camCookieName, camId, camCookieDays);
  }
  return camId;
};

export const getOcid = () => {
  let ocid = getCookie('ocid');
  if (ocid === null || ocid === '') {
    ocid = getParameterByName('ocid');
    setCookie('ocid', ocid, camCookieDays);
  }
  return ocid;
};

export const getPOcid = () => {
  let pocid = getCookie('pocid');
  if (pocid === null || pocid === '') {
    pocid = getParameterByName('pocid');
    setCookie('pocid', pocid, camCookieDays);
  }
  return pocid;
};

export const getObid = () => {
  let obid = getCookie('obid');
  if (obid === null || obid === '') {
    obid = getParameterByName('obid');
    setCookie('obid', obid, camCookieDays);
  }
  return obid;
};

export const getAid = () => {
  let aid = getCookie('a');
  if (aid === null || aid === '') {
    aid = getParameterByName('a');
    setCookie('a', aid, camCookieDays);
  }
  return aid;
};
